module.exports = __webpack_public_path__ + "static/media/favicon.66badd02.ico";


//////////////////
// WEBPACK FOOTER
// ./src/img/favicon.ico
// module id = 834
// module chunks = 0